<template>
  <div :class="'profile-summary'">
    <!--@each(row in detailLeftTop)-->
    <div
      v-for="row in detailLeftTop"
      :class="'row summary-item' + (row.parentClass ? row.parentClass : '')"
      v-bind:key="row.key"
    >
      <!--@each(item in row.columns)-->
      <div
        v-for="item in row.columns"
        :class="
          'col-md-' +
          (row.colnum ? 12 / row.colnum : item.colwidth ? item.colwidth : 12)
        "
        v-bind:key="item.label + Math.random(1023)"
      >
        <div :class="'item ' + (item.className ? item.className : '')">
          <!--@if(item.type!='no-icon' && item.icon)-->
          <span v-if="item.type != 'no-icon' && item.icon">
            <i :class="'material-symbols-outlined'">{{ item.icon }}</i>
          </span>
          <!--@endif-->
          <div>
            <!--@if(item.label)-->
            <span
              v-if="item.label"
              :class="'item-label ' + (item.labelClass ? item.labelClass : '')"
              >{{ item.label }}</span
            >
            <!--@endif-->
            <!--@if(item.content)-->
            <div v-if="item.content">
              <a
                :href="item.content"
                target="_blank"
                v-if="item.type == 'image'"
                style="width:100%"
              >
                <img
                  :src="item.content"
                  alt=""
                  style="width: 100%; height: auto"
                />
              </a>
              <a
                :href="item.content"
                target="_blank"
                v-else-if="item.type == 'file'"
              >
                Download File
              </a>
              <h5
                v-else
                :class="'item-content'"
                v-html="
                  item.content && item.content != null && item.content != 'null'
                    ? item.content
                    : 'Tidak Ada'
                "
                style="white-space: pre-wrap"
              >
                <!-- {{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }} -->
              </h5>
            </div>
            <div
              v-if="item.actionBtn && item.actionBtn.length"
              class="action mt-2"
            >
              <!-- @each(item in item.actionBtn) -->
              <span v-for="(item, i) in item.actionBtn" v-bind:key="item.label">
                <!-- @if(item.type=='status') -->
                <span
                  v-if="item.type == 'status'"
                  :class="'badge ' + item.className + (i ? ' ml-2' : '')"
                >
                  <!-- @if(item.iconLeft) -->
                  <i v-if="item.iconLeft" class="material-symbols-outlined">{{
                    item.iconLeft
                  }}</i>
                  <!-- @endif -->
                  {{ item.label }}
                  <!-- @if(item.iconRight) -->
                  <i v-if="item.iconRight" class="material-symbols-outlined">{{
                    item.iconRight
                  }}</i>
                  <!-- @endif -->
                </span>
                <!-- @else -->
                <span v-else>
                  <button
                    v-if="item.type == 'modal'"
                    :data-target="item.link"
                    data-toggle="modal"
                    :class="
                      'btn ' +
                      (item.class ? item.class : '') +
                      (i ? ' ml-2' : '')
                    "
                    id="item.id"
                  >
                    <!-- @if(item.iconLeft) -->
                    <i v-if="item.iconLeft" class="material-symbols-outlined">{{
                      item.iconLeft
                    }}</i>
                    <!-- @endif -->
                    {{ item.label }}
                    <!-- @if(item.iconRight) -->
                    <i v-if="item.iconRight" class="material-symbols-outlined">{{
                      item.iconRight
                    }}</i>
                    <!-- @endif -->
                  </button>
                  <button
                    v-else-if="item.type == 'function'"
                    @click="item.function"
                    :class="
                      'btn ' +
                      (item.class ? item.class : '') +
                      (i ? ' ml-2' : '')
                    "
                    id="item.id"
                  >
                    <!-- @if(item.iconLeft) -->
                    <i v-if="item.iconLeft" class="material-symbols-outlined">{{
                      item.iconLeft
                    }}</i>
                    <!-- @endif -->
                    {{ item.label }}
                    <!-- @if(item.iconRight) -->
                    <i v-if="item.iconRight" class="material-symbols-outlined">{{
                      item.iconRight
                    }}</i>
                    <!-- @endif -->
                  </button>
                  <a
                    v-else
                    :href="item.link"
                    :class="
                      'btn ' +
                      (item.class ? item.class : '') +
                      (i ? ' ml-2' : '')
                    "
                    id="item.id"
                    :target="item.target"
                  >
                    <!-- @if(item.iconLeft) -->
                    <i v-if="item.iconLeft" class="material-symbols-outlined">{{
                      item.iconLeft
                    }}</i>
                    <!-- @endif -->
                    {{ item.label }}
                    <!-- @if(item.iconRight) -->
                    <i v-if="item.iconRight" class="material-symbols-outlined">{{
                      item.iconRight
                    }}</i>
                    <!-- @endif -->
                  </a>
                </span>
                <!-- @endif -->
              </span>
              <!-- @endeach -->
            </div>
            <!--@endif-->
          </div>
          <!--@if(item.action)-->
          <router-link
            v-if="item.action"
            :class="'btn btn-sm btn-with-icon-right btn-outline-secondary float-right ml-3'"
            :to="item.action.link"
            target="_blank"
            >{{ item.action.label
            }}<i :class="'material-symbols-outlined'">arrow_forward</i></router-link
          >
          <!--@endif-->
        </div>
      </div>
      <!--@endeach-->
    </div>
    <!--@endeach-->
    <!--@each(input in detailLeftBottom)-->

    <div v-if="detailLeftBottom && detailLeftBottom.length">
      <div
        v-for="input in detailLeftBottom"
        v-bind:key="input.key"
        :class="'with-bg mt-3'"
      >
        <!--{{ csrfField() }}-->
        <!--@include('blocks.formTemplate')-->
        <!--@if(input.btn)-->
        <form :enctype="input.enctype || ''" method="POST">
          <FormRow :row="input" />
          <button
            v-if="input.btn"
            :class="'btn ' + input.btn.className"
            type="submit"
            :formaction="input.btn.action"
            :id="input.btn.id || Math.random(1000)"
          >
            <!--@if(input.btn.iconLeft)-->
            <i v-if="input.btn.iconLeft" :class="'material-symbols-outlined'">{{
              input.btn.iconLeft
            }}</i>
            <!--@endif-->
            {{ input.btn.label }}
            <!--@if(input.btn.iconRight)-->
            <i v-if="input.btn.iconRight" :class="'material-symbols-outlined'">{{
              input.btn.iconRight
            }}</i>
            <!--@endif-->
          </button>
          <!--@endif-->
        </form>
      </div>
    </div>
    <!--@endeach-->
  </div>
</template>
<style scoped>
img {
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
}
</style>
<script>
import FormRow from "./FormRow.vue";
export default {
  name: "DetailLeft",
  components: {
    FormRow,
  },
  props: {
    detailLeftTop: Array,
    detailLeftBottom: Array,
  },
};
</script>